import { useBannerOrBlocker } from "../useBannerOrBlocker.js";
function useGroupItems(map) {
    const { groups } = useBannerOrBlocker();
    let result = groups.map(({ items })=>[
            ...items
        ]).flat();
    if (map) {
        result = result.map(map).filter(Boolean);
    }
    return result;
}
export { useGroupItems };
